import React, { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import BuyNowTextBox, { IBuyNowTextBoxClasses, IBuyNowTextBoxProps } from "./BuyNowTextBox";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
        },
        titleContainer: {
            position: "relative",
            zIndex: 1000,
            display: "flex",
            alignItems: "flex-end",
            "& img": { width: "100%" },
        },
        title: {
            zIndex: 100,
        },
        titlePrefix: {
            flex: "2",
            marginLeft: theme.spacing(2),
        },
        titleSuffix: { flex: "1" },
        textBox: { marginTop: -theme.spacing(4), flex: "1" },
        textBoxRoot: { paddingTop: theme.spacing(4) },
    });
});

type IClasses = Partial<ReturnType<typeof useStyles>>;

interface IProps extends IBuyNowTextBoxProps {
    children?: ReactNode;
    titlePrefixComponent?: ReactNode;
    titleSuffixComponent?: ReactNode;
    textContainerClasses?: IBuyNowTextBoxClasses;
    classes?: IClasses;
}

export default function BuyNowTextBoxWithAdornments(props: IProps) {
    const classes = useStyles();
    const {
        className,
        children,
        titlePrefixComponent,
        titleSuffixComponent,
        textContainerClasses,
        classes: overrideClasses,
        ...rest
    } = props;

    return (
        <div className={clsx(className, classes.root, overrideClasses?.root)} {...rest}>
            <div className={clsx(classes.titleContainer, overrideClasses?.titleContainer)}>
                <div
                    className={clsx(
                        classes.title,
                        overrideClasses?.title,
                        classes.titlePrefix,
                        overrideClasses?.titlePrefix
                    )}
                >
                    {titlePrefixComponent}
                </div>

                {typeof titleSuffixComponent === "undefined" ? null : (
                    <div
                        className={clsx(
                            classes.title,
                            overrideClasses?.title,
                            classes.titleSuffix,
                            overrideClasses?.titleSuffix
                        )}
                    >
                        {titleSuffixComponent}
                    </div>
                )}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className={clsx(classes.textBox, overrideClasses?.textBox)}>
                    <BuyNowTextBox classes={textContainerClasses} className={classes.textBoxRoot}>
                        {children}
                    </BuyNowTextBox>
                </div>
            </div>
        </div>
    );
}
